
function SdStatusSubtitlesCtrl(TranslationService) {
    var ctrl = this;
    
}

SdStatusSubtitlesCtrl.$inject = ['TranslationService'];

seedWebApp.component('sdSitPortal', {
    controller: SdStatusSubtitlesCtrl,
    bindings: {
        sitPortal: '<',
    },
    templateUrl: '/SPA/Components/sd-sit-portal.html' + seedWebApp.buildVersion
});